import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { config } from 'config'
import HomeArticle from '../components/HomeArticle'

export default class Index extends React.Component {
  render () {
    return (
      <div style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        <Helmet
          title={config.siteTitle}
          meta={[
            {"name": "description", "content": "dasProject - Leben mit Beeinträchtigung"},
            {"name": "keywords", "content": "dasProject, dasprojectco, Behinderung, Beeinträchtigung, Fotografie, Diplomprojekt, die Graphische, Graphsiche, Wien"},
          ]}
        />

        <HomeArticle />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./index.js